module.exports = __webpack_public_path__ + "static/img/TACCHELLA.bb817e15.jpg";